
import { supabase } from '@/integrations/supabase/client';

// Check if URL is a valid Supabase storage URL
export const isSupabaseStorageUrl = (url: string): boolean => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.hostname.includes('supabase') && 
           parsedUrl.pathname.includes('/storage/');
  } catch (e) {
    console.error('Invalid URL format:', url);
    return false;
  }
};

// Check if an image file is valid
export const validateImageFile = (file: File): Promise<boolean> => {
  return new Promise((resolve, reject) => {
    // Check file size
    if (file.size === 0) {
      reject(new Error("Le fichier est vide"));
      return;
    }

    // Create object URL and test loading the image
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    
    img.onload = () => {
      URL.revokeObjectURL(objectUrl);
      resolve(true);
    };
    
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("L'image n'est pas valide ou est corrompue"));
    };
    
    img.src = objectUrl;
  });
};

// Verify uploaded file by fetching its metadata
export const verifyUploadedFile = async (bucket: string, filePath: string): Promise<boolean> => {
  try {
    console.log(`Verifying uploaded file in bucket: ${bucket}, path: ${filePath}`);
    
    // Get public URL for the file
    const { data } = await supabase.storage
      .from(bucket)
      .getPublicUrl(filePath);
    
    if (!data || !data.publicUrl) {
      console.error("Error getting file metadata: No publicUrl returned");
      return false;
    }
    
    // Add cache buster to avoid potential caching issues
    const publicUrl = new URL(data.publicUrl);
    publicUrl.searchParams.set('t', Date.now().toString());
    
    // Test fetch the image to ensure it's accessible
    const response = await fetch(publicUrl.toString(), { 
      method: 'HEAD',
      mode: 'cors',
      cache: 'no-cache'
    });
    
    if (!response.ok) {
      console.error(`File not accessible: ${response.status} ${response.statusText}`);
      return false;
    }
    
    console.log(`File verified successfully: ${filePath}`);
    return true;
  } catch (error) {
    console.error("Error verifying uploaded file:", error);
    return false;
  }
};
